<div class="trial-dialog">
  <div class="header">
    <h2>{{ title }}</h2>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="text-section">
      <p class="description" [innerHTML]="description"></p>

      <div class="benefits">
        <p><strong>Você terá acesso à</strong></p>
        <ul>
          <li>Cadastro de produto</li>
          <li>Relatório de vendas</li>
          <li>Multi PDVs</li>
        </ul>
      </div>
    </div>

    <div class="illustration">
      <img src="assets/image/trial-illustration.png" alt="Ilustração" />
    </div>
  </div>

  <div class="actions">
    <a href="{{websiteUrl}}" target="_blank">
      <button mat-flat-button color="primary" class="btn-plans">
        Conheça nossos planos
      </button>
    </a>
  </div>
</div>
